import Link from '@/components/Link';
import Container from '@/components/Container';
import RemoteImage from '@/components/Image/RemoteImage';
import client from '@/api/client';
import { materialQuery, materialsSlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: materialQuery,
    variables: {
      id: params.slug,
    },
  });

  return {
    props: {
      material: data?.material,
    },
  };
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: materialsSlugsQuery });

  const paths = data?.materials?.nodes?.map(({ slug }) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false,
  };
}

export default function ScrumMaterialSinglePage({ material }) {
  return (
    <div className="py-10 bg-gradient-to-b from-gray-100 to-white">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14 xl:gap-16">
          <div className="lg:col-span-4 xl:col-span-5 lg:flex lg:items-start">
            <div className="relative inline-flex overflow-hidden bg-gray-200 rounded-lg shadow-lg bg-gradient-to-b from-gray-200 to-gray-50 ring-1 ring-black ring-opacity-10 lg:sticky lg:top-32 lg:rounded-xl lg:shadow-xl xl:rounded-2xl lg:w-full">
              <div className="absolute inset-0" />
              <div className="flex justify-center">
                <RemoteImage
                  className="relative z-0 object-cover shadow-xl select-none border-opacity-20"
                  width={570}
                  height={806}
                  src={material.featuredImage.node.sourceUrl}
                  alt={material.featuredImage.node.title}
                />
              </div>
            </div>
          </div>
          <div className="space-y-4 lg:col-span-8 lg:space-y-6 lg:py-10 xl:col-span-7 xl:space-y-8">
            <div className="space-y-4">
              <Link
                className="inline-flex items-center space-x-2 text-lg font-semibold text-green-500"
                href="/recursos/materiales"
              >
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <div>Todos los materiales</div>
              </Link>
              <h1 className="text-3xl font-semibold tracking-tight lg:text-4xl lg:font-extrabold xl:text-5xl">
                {material.title}
              </h1>
              {material.info.reference && (
                <blockquote className="text-gray-500 lg:text-sm">
                  {`Referencia: ${material.info.reference}`}
                </blockquote>
              )}
            </div>
            <div
              className="prose lg:prose-lg"
              dangerouslySetInnerHTML={{ __html: material.content }}
            />
            <hr />
            <div className="pt-2 space-y-4">
              <a
                className="inline-flex items-center px-4 space-x-2 text-lg font-medium leading-10 text-white bg-green-500 rounded-full hover:bg-green-600 focus:bg-green-600 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:px-6 lg:py-1"
                href={material.info.pdf.sourceUrl}
                download
                role="button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                  />
                </svg>
                <div>Descargar material</div>
              </a>
              <div className="text-sm text-gray-500">
                La descarga del material se ralizará en formato PDF
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
